export default "__VITE_ASSET__CozJgttU__"